module.exports = __webpack_public_path__ + "img/CHEDRAUI.a5a68abb.png";